module.exports = __webpack_public_path__ + "static/Daily-burn-logo-d651dcb3e250fe1f215bbc8e4f4e60f5.svg";